import React from 'react'

export const NegativeIcon = props => {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.76703e-05 8.98198C0.00940896 4.02886 4.0461 0 8.99922 0C13.9797 0.00860868 18.0094 4.05391 18 9.01642C17.9906 13.9695 13.9523 18 9 18H8.98278C6.57783 17.9953 4.32001 17.0546 2.62332 15.3516C0.926625 13.6479 -0.00467797 11.3862 1.76703e-05 8.98198ZM12.5906 12.0506C12.7424 12.2032 12.7416 12.4513 12.589 12.6039C12.5123 12.6806 12.413 12.7181 12.3136 12.7181C12.2134 12.7181 12.1124 12.6798 12.0357 12.6031L8.99765 9.55329L5.9494 12.5914C5.8727 12.6673 5.77253 12.7048 5.67235 12.7048C5.57218 12.7048 5.47201 12.6665 5.39609 12.5906C5.2427 12.4364 5.2427 12.1891 5.39688 12.0373L8.44591 8.9992L5.40783 5.94938C5.25523 5.79599 5.25601 5.5479 5.4094 5.39608C5.56279 5.24269 5.81009 5.24347 5.9627 5.39686L9 8.44668L12.0498 5.40938C12.2024 5.25599 12.4505 5.25599 12.6031 5.41016C12.7557 5.56277 12.7557 5.81008 12.6023 5.96347L9.55252 9.00155L12.5906 12.0506Z"
				fill="#ef7f43"
			/>
		</svg>
	)
}
